/**
 * Component Registry for Regatta
 * 
 * Inherits from @vibesites-apartment-management-consultants/theme-avenue and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-apartment-management-consultants/theme-avenue/registry';
import { SpecialOfferBanner } from './components/SpecialOfferBanner';
import SitemapContent from './components/SitemapContent';
import SocialFollow from './components/SocialFollow';
import Gallery from './components/Gallery';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  SpecialOfferBanner,
  SitemapContent,
  SocialFollow,
  Gallery,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
